import { render, staticRenderFns } from "./DoctorPortal.vue?vue&type=template&id=1d23a174&scoped=true&lang=pug"
import script from "./DoctorPortal.vue?vue&type=script&lang=js"
export * from "./DoctorPortal.vue?vue&type=script&lang=js"
import style0 from "./DoctorPortal.vue?vue&type=style&index=0&id=1d23a174&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d23a174",
  null
  
)

export default component.exports